import type { PolicyGetResponse } from '@lio/api-types';

export const getPrimaryJurisdictionAbbreviation = (policy: PolicyGetResponse): string => {
  const primaryAddress = policy?.boundQuote?.quoteLocations.find((location) => location.insuredLocation.isPrimary);
  const stateFromAddress = primaryAddress?.insuredLocation.address.jurisdiction.abbreviation;
  return stateFromAddress?.toUpperCase() ?? '';
};

export const getCancelationGrounds = async (policy: PolicyGetResponse, writingCompany: string): Promise<string[]> => {
  const { default: lookup } = await import('./cancelationGrounds.json');
  const state = getPrimaryJurisdictionAbbreviation(policy);
  return (lookup as Record<string, Record<string, string[]>>)[state]?.[writingCompany] ?? [];
};
